/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Content } from './content';
import { ContentProvider } from './contentProvider';
import { ServiceProviders } from './serviceProviders';

export interface ContentServiceProviders { 
    _id?: string;
    contentProvider?: ContentProvider;
    serviceProvider?: ServiceProviders;
    content?: Content;
    status?: number;
}